import React, { useMemo } from 'react';
import { generatePath, useLocation } from 'react-router-dom';

import {
  SiteConfigManager,
  useCategoryState,
  useSportState,
  useTournamentState,
} from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import { searchQuerySymbol } from 'common/constants';

import TournamentHeaderView from './TournamentHeaderView';

const { SPORT_PREMATCH } = COMPONENT_TYPES;

const TournamentHeader = () => {
  const { name: sportName, urlName: sportUrlName } = useSportState();
  const tournament = useTournamentState();

  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const searchString = searchParams.get(searchQuerySymbol);

  const prematchPath = SiteConfigManager.getExtraConfig(`pathList.${SPORT_PREMATCH}`);

  const { name: categoryName } = useCategoryState();

  // we can't use {path} from useRouteMatch because in path "/:sportName/:categoryName/:tournamentName" tournamentName is required
  const generatedBackPath = useMemo(
    () =>
      generatePath(`${prematchPath}/:sportName`, {
        sportName: sportUrlName,
      }),
    [sportUrlName, prematchPath],
  );

  const backPath = `${generatedBackPath}${
    searchString ? `?${searchQuerySymbol}=${searchString}` : ''
  }`;

  return (
    <TournamentHeaderView
      backPath={backPath}
      categoryName={categoryName}
      sportName={sportName}
      tournament={tournament}
    />
  );
};

export default TournamentHeader;
